export const menuListLarge = {
  maintenance: 'Wartung',
  modernization: 'Modernisierung',
  emergencyCall: 'Notruf',
  newConstruction: 'Neubau',
  getPartner: 'Partner werden',
  aboutUs: 'Über uns',
}
